import { findUniqueValuesIn } from "./common";

class Country {
  constructor(name) {
    this.name = name;
    this.territories = {};
  }
}

class StateProvince {
  constructor(name) {
    this.name = name;
    this.counties = [];
  }
}

class CSCLookup {
  constructor(baseData) {
    this.baseData = baseData;
    this.countries = {};
    this.baseData.forEach((dataPoint) => {
      dataPoint.Locations.forEach((location) => {

        if (!this.countries[location.Country]) {
          this.countries[location.Country] = new Country(location.Country);
        }

        let currentState = this.countries[location.Country].territories[
          location.State
        ];
        if (!currentState) {
          currentState = new StateProvince(location.State);
          currentState.counties = Array.from(new Set(location.County));
          this.countries[location.Country].territories[
            location.State
          ] = currentState;
        } else {
          let tmpCounties = [...currentState.counties];
          const tmp = { ...currentState };
          tmpCounties = tmpCounties.concat(location.County);
          tmpCounties = Array.from(new Set(tmpCounties));
          tmp.counties = [...tmpCounties];
          this.countries[location.Country].territories[location.State] = {
            ...tmp,
          };

        }
      });
    });
  }

  getCountiesByTerritory(country, territory) {
    return this.sort(this.countries[country].territories[territory].counties);
  }

  getCountries() {
    return Object.keys(this.countries);
  }

  getTerritoriesByCountry(country) {
    const unsorted = Object.keys(this.countries[country].territories);
    const sorted = this.sort(unsorted);
    return sorted;
  }

  sort(values) {
    return values.sort((a, b) => {
      let nameA = a.toUpperCase(); // ignore upper and lowercase
      let nameB = b.toUpperCase(); // ignore upper and lowercase
      if (nameA > nameB) {
        return 1;
      }
      if (nameA < nameB) {
        return -1;
      }
      // names must be equal
      return 0;
    });
  }
}

export default CSCLookup;
